import { TextField, Button, Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import AddIcon from '@mui/icons-material/Add';

function AddPeer(props)
{
    const divisions = [
        "Electrical",
        "Low Voltage",
        "HVAC/Sheet Metal/Mechanical",
        "Architectural Metal and Glass",
        "Civil",
        "General Contractor",
        "Glass and Glazing",
        "Paving and Grading",
        "Plumbing",
        "Mechanical"
    ];

    const [newPeer, setNewPeer] = useState("");
    const [selectedDivision, setSelectedDivision] = useState("");
    
    const addPeer=()=>{
        if(newPeer!=="")
        {
        axios({
            // Endpoint to send files
            url: process.env.REACT_APP_API_URL+'peergroup',
            method: "POST",
            data:{ 
                peerName: newPeer,
                division: selectedDivision 
            },
            headers: {
                // Add any auth token here
                //authorization: "your token comes here",
            },
        }).then((res) => {
            //refreshPeers();
            props.refreshList();
        }).catch((err) => {
            console.log(err)
        });
        setNewPeer("");
        setSelectedDivision("");
        //Load up the full peer list so we can work with it
        //refreshPeers();
        }
    };


    return(
        <>
        <div className='formRow'>     
            <div className='formGroup'>
                <TextField className='formControl' label="New Peer Group" variant="outlined" onChange={(e)=>setNewPeer(e.target.value)} value={newPeer}/>
            </div>
        </div>
        <div className='formRow'>     
            <div className='formGroup'>
                <FormControl className='formControl' variant="outlined" fullWidth>
                    <InputLabel>Division</InputLabel>
                    <Select
                        value={selectedDivision}
                        onChange={(e) => setSelectedDivision(e.target.value)}
                        label="Division"
                    >
                        {divisions.map((division) => (
                            <MenuItem key={division} value={division}>
                                {division}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        </div>
        <div className="formRow">
            <div className='formGroup'>
                <Button 
                    variant="outlined" 
                    startIcon={<AddIcon/>}  
                    size='small' 
                    onClick={addPeer}
                    disabled={newPeer === "" || selectedDivision === ""}
                >
                    Add Peer Group
                </Button>  
            </div>
        </div>
        </>
    );
}

export default AddPeer;